import axios from 'axios';
import { ADMIN_DAILY_DATA_ROUTE } from '../../api/backend';
import { Paginated } from '../../common/types';
import { DailyData } from '../../common/model/dto/daily-data';

export const loadDailyDataBetweenDateRange = async (query: string) => {
  const { data } = await axios.get<Paginated<DailyData>>(
    `${ADMIN_DAILY_DATA_ROUTE}?${query}`
  );

  return data;
};
